/**
 * GDPR cookie consent banner: first-visit only.
 * Accept All | Reject All | Customise (opens preferences modal).
 */

import { useConsent } from './useConsent';
import { ACCEPT_ALL_CONSENT, REJECT_ALL_CONSENT } from './types';
import LureoButton from '@/common/LureoButton';
import { Banner } from '@/components/ui/banner';

export function CookieBanner() {
  const {
    hasConsented,
    bannerOpen,
    setBannerOpen,
    setConsentAndApply,
    setPreferencesOpen,
  } = useConsent();

  if (!bannerOpen || hasConsented) return null;

  const handleAcceptAll = () => {
    setConsentAndApply(ACCEPT_ALL_CONSENT);
    setBannerOpen(false);
  };

  const handleRejectAll = () => {
    setConsentAndApply(REJECT_ALL_CONSENT);
    setBannerOpen(false);
  };

  const handleCustomise = () => {
    setBannerOpen(false);
    setPreferencesOpen(true);
  };

  // bottom-start sits above dialogs: answering it must work while one is open
  return (
    <Banner
      role="dialog"
      aria-label="Cookie consent"
      data-cookie-consent
      place="bottom-start"
      actions={
        <>
          <LureoButton
            variant="outline-3"
            onClick={handleAcceptAll}
            className="h-9 rounded-lureo-radius-button-pill px-5"
            suppressTooltip
          >
            Accept All
          </LureoButton>
          <LureoButton
            variant="no-outline"
            onClick={handleRejectAll}
            className="h-9 rounded-lureo-radius-button-pill px-4"
            suppressTooltip
          >
            Reject All
          </LureoButton>
          <LureoButton
            variant="no-outline"
            onClick={handleCustomise}
            className="h-9 rounded-lureo-radius-button-pill px-4"
            suppressTooltip
          >
            Customise
          </LureoButton>
        </>
      }
    >
      We use cookies to improve your experience, analyse traffic and support sign-in. You can choose which categories to
      allow. Necessary cookies are always active.
    </Banner>
  );
}
